@if (hasTrack()) {
  <dl
    class="stats-footer card elevation-2 flex-row flex-wrap align-items-center m-0 py-3 px-5 si-caption text-nowrap"
  >
    @if (stats().hasBeeline) {
      <dd
        class="stats-footer__warning m-0"
        [title]="'BROUTER_MAP.STATS.BEELINE_WARNING' | translate"
      >
        <i class="icon element-warning"></i>
      </dd>
    }

    <div class="d-inline-flex align-items-baseline gap-2" [title]="distancePrecise() + ' km'">
      <dt class="stats-footer__muted fw-normal">{{ 'BROUTER_MAP.STATS.DISTANCE' | translate }}</dt>
      <dd class="stats-footer__value m-0">{{ distance() }}</dd>
      <dd class="stats-footer__muted m-0">km</dd>
    </div>

    <div class="d-inline-flex align-items-baseline gap-2" [title]="totalTimePrecise() + ' h'">
      <dt class="stats-footer__muted fw-normal">{{ 'BROUTER_MAP.STATS.TIME' | translate }}</dt>
      <dd class="stats-footer__value m-0">{{ totalTime() }}</dd>
      <dd class="stats-footer__muted m-0">h</dd>
    </div>

    <div class="d-inline-flex align-items-baseline gap-2">
      <dt class="stats-footer__muted fw-normal">{{ 'BROUTER_MAP.STATS.ENERGY' | translate }}</dt>
      <dd class="stats-footer__value m-0">{{ totalEnergy() }}</dd>
      <dd class="stats-footer__muted m-0">kWh</dd>
      <dd class="stats-footer__muted m-0">|</dd>
      <dd class="stats-footer__value m-0">{{ meanEnergy() }}</dd>
      <dd class="stats-footer__muted m-0">Wh/km</dd>
    </div>

    <div class="d-inline-flex align-items-baseline gap-2">
      <dt class="stats-footer__muted fw-normal">{{ 'BROUTER_MAP.STATS.ASCEND' | translate }}</dt>
      <dd class="stats-footer__value m-0">{{ ascend() }}</dd>
      <dd class="stats-footer__muted m-0">|</dd>
      <dd class="stats-footer__value m-0">{{ plainAscend() }}</dd>
      <dd class="stats-footer__muted m-0">m</dd>
    </div>

    <div class="d-inline-flex align-items-baseline gap-2">
      <dt class="stats-footer__muted fw-normal">{{ 'BROUTER_MAP.STATS.COST' | translate }}</dt>
      <dd class="stats-footer__value m-0">{{ cost() }}</dd>
      <dd class="stats-footer__muted m-0">|</dd>
      <dd class="stats-footer__value m-0">{{ meanCostFactor() }}</dd>
    </div>
  </dl>
}
